import sideBarDefaultLogoMode from "@assets/images/imagotipo.png";
import sideBarDefaultLogoDarkMode from "@assets/images/imagotipo-dark.png";
import { useLegacyThemeHandler } from "@dashboard/components/Sidebar/user/Controls";
import { Box, Text } from "@saleor/macaw-ui-next";
import React from "react";

export const MountingPoint = () => {
  const { theme } = useLegacyThemeHandler();
  const logo = theme === "defaultLight" ? sideBarDefaultLogoMode : sideBarDefaultLogoDarkMode;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={3}
      paddingX={4}
      paddingY={5}
      alignItems="center"
    >
      <img src={logo} alt={logo} style={{ height: "100%", width: "200px" }} />
      <Text size={5} fontWeight="bold">
        Dashboard
      </Text>
    </Box>
  );
};
